<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: { },
  data () {
    return {
      browserSize: null
    }
  },
  computed: {
    browserSize1: {
      set: function (data) {
        this.$store.dispatch('browserSize', data)
        return this.$store.state.browserSize
      },
      get: function () {
        return this.$store.state.browserSize
      }
    }
  },
  methods: {
    goUrl () {
      this.$router.push('/about')
    },
    getRatio () {
      // 获取浏览器缩放比例
      let ratio = 0
      const screen = window.screen
      const ua = navigator.userAgent.toLowerCase()
      if (window.devicePixelRatio !== undefined) {
        ratio = window.devicePixelRatio
      } else if (~ua.indexOf('msie')) {
        if (screen.deviceXDPI && screen.logicalXDPI) {
          ratio = screen.deviceXDPI / screen.logicalXDPI
        }
      } else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
        ratio = window.outerWidth / window.innerWidth
      }
      if (ratio) {
        ratio = Math.round(ratio * 100)
      }
      return ratio
    }
  },
  created () {
    // 第一次进来时需要执行
    this.browserSize = this.getRatio()
  },
  mounted () {
    // 监听窗口大小
    window.onresize = () => {
      return (() => {
        this.browserSize = this.getRatio()
        setTimeout(() => {
          this.$store.dispatch('browserWidth', window.outerWidth)
        })
      })()
    }
  },
  watch: {
    // '$route' () {
    //   this.publicJs.queryUrlParams()
    // }
    browserSize (newData) {
      this.browserSize = newData
      this.$store.dispatch('browserSize', newData)
    }
  }
}
</script>

<style lang="scss">
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 100%;
    overflow-x: hidden !important;
  }
  html {
    width: 100%;
    height: 100%;
    font-size: 62.5%;
    @media screen and (max-width: 1280px) {
      font-size: 52%;
    }
  }
  body{
    width: 100%;
    height: 100%;
    font-size: 1.6rem;
  }
  * {
    margin: 0;
    padding: 0;
  }

  b {
    font-weight: normal;
  }

  html {
    min-height: 100%;
  }
  body {
    padding: 0;
    margin: 0;
    font-weight: normal;
    min-height: 100%;
    background: #ffffff;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  img,
  input,
  select {
    vertical-align: middle;
  }
  input::-ms-clear{display:none;}
  input::-ms-reveal{display:none;}
  img {
    border: 0;
  }
  input::-webkit-input-placeholder { /* WebKit browsers */
    color:#bbb;
  }
  input::-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    color:#bbb;
  }
  input::-moz-placeholder { /* Mozilla Firefox 19+ */
    color:#bbb;
  }
  input::-ms-input-placeholder { /* Internet Explorer 10+ */
    color:#bbb;
  }
  textarea::-webkit-input-placeholder { /* WebKit browsers */
    color:#bbb;
  }
  textarea::-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    color:#bbb;
  }
  textarea::-moz-placeholder { /* Mozilla Firefox 19+ */
    color:#bbb;
  }
  textarea::-ms-input-placeholder { /* Internet Explorer 10+ */
    color:#bbb;
  }
  li {
    list-style-type: none;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  th,
  td {
    padding: 0;
  }

  input,
  button,
  select,
  textarea {
    outline: none;
    resize: none;
  }

  a {
    outline: medium none;
    text-decoration: none;
    cursor: pointer;
  }

  a:hover {
    text-decoration: none;
  }

  /*网上找的页面过度效果*/
  .vux-pop-out-enter-active,
  .vux-pop-out-leave-active,
  .vux-pop-in-enter-active,
  .vux-pop-in-leave-active {
    will-change: transform;
    transition: all 0.3s;
    height: 100%;
    top: 0;
    position: absolute;
    backface-visibility: hidden;
    perspective: 1000;
  }
  .vux-pop-out-leave-active{
    z-index: 99;
  }
  .vux-pop-out-enter {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }

  .vux-pop-out-leave-active {
    opacity: 1;
    transform: translate3d(0, 100%, 0);
  }

  .vux-pop-in-enter {
    opacity: 1;
    transform: translate3d(0, 100%, 0);
  }

  .vux-pop-in-leave-active {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
  .clear
  {
    height:0px;
    clear:both;
    font-size:0px;
    line-height:0px;
    zoom: 1;
  }

  /*弹窗后固定背景*/
  .fixbgbody{
    overflow-y: hidden;
    position: fixed;
  }

  /* 父级清浮动 */
  .clearfa{
    clear: both;
    overflow: auto;
  }
  //a:link, a:visited {
  //  text-decoration: none;
  //  color: #1F376D;
  //}
  //a:hover, a:active {
  //  text-decoration: underline;
  //  color: #BD0A01;
  //  /*border: none;*/
  //}
  ul {
    clear:both;
    overflow:hidden;
    /*width: 100%;*/
  }
  ul, li {
    list-style:none;
  }
  .valign {
    display:table-cell;
    *display: inline;
    zoom:1;
    vertical-align:middle;
  }
  .text{word-wrap:break-word;overflow:hidden;word-break:break-all;}
  /*======================CSS垂直居中=======================*/
  .holder {
    width:740px;
    height:300px;
    border:1px solid #777;
    text-align:center;
    display:table-cell;
    vertical-align:middle;
  }
  /*以下样式针对IE*/
  .edge {
    width:0;
    height:100%;
    display:inline-block;
    vertical-align:middle;
  }
  .container {
    vertical-align:middle;
    display:inline-block;
  }
  /*===============================================*/

  /*CSS Hack*/
  .class {
    background-color:#FFFF00;/*所有浏览器*/
    *background-color:#00FF00;/*IE*/
    _background-color:#00FFFF;/*IE6*/
  }
  .modal{
    .modalMust {
      &:before{
        content:'*';
        color: red;
        font-size: 14px;
      }
    }
    .modalNotMust{
      &:before{
        content: '\00A0';
        font-size: 14px;
      }
    }
    .modalTitle {
      font-size: 14px;
      font-weight: bold;
      height: 14px;
    }
  }
</style>
